import React from 'react';
import './index.scss';

export const BottomDrawer = ({ children }) => {
  return (
    <div className={'bottom-drawer-wrapper zds-body-m'}>
      <hr />
      {children}
    </div>
  );
};
